export const PREFERRED_LOCALE_COOKIE = "preferred-locale";
export const PREFERRED_LANGUAGES = ["en", "et", "ru", "lv", "lt", "pl"];

export const getSupportedPreferredLanguage = (
  value,
  locales = PREFERRED_LANGUAGES,
) =>
  PREFERRED_LANGUAGES.includes(value) && locales.includes(value) ? value : null;

// Only an unlocalized document entry may adopt a preference. Client-side Next
// data requests (including header language switches) keep their chosen locale.
export function getPreferredHomeRedirect({
  originalUrl,
  locale,
  defaultLocale,
  locales,
  preferredLocale,
  lang,
  isCorporate,
  isDataRequest,
}) {
  if (!originalUrl || isDataRequest || locale !== defaultLocale) return null;
  const url = new URL(originalUrl, "http://localhost");
  if (url.pathname !== "/") return null;

  const preferred = !isCorporate
    ? getSupportedPreferredLanguage(preferredLocale, locales)
    : null;
  const target = preferred || getSupportedPreferredLanguage(lang, locales);
  if (!target || target === defaultLocale) return null;
  return `/${target}/${url.search}`;
}
